// USA
export const locale = {
	lang: 'en',
	data: {
		TRANSLATOR: {
			SELECT: 'Select your language',
		},

		HEADER: {
			GREETING: 'HI, '
		},
		MENU: {
			NEW: 'new',
			ACTIONS: 'Actions',
			CREATE_POST: 'Create New Post',
			PAGES: 'Pages',
			FEATURES: 'Features',
			APPS: 'Apps',
			DASHBOARD: 'Dashboard',
		},
		AUTH: {
			GENERAL: {
				OR: 'Or',
				SUBMIT_BUTTON: 'Submit',
				NO_ACCOUNT: 'Don\'t have an account?',
				SIGNUP_BUTTON: 'Sign Up',
				FORGOT_BUTTON: 'Forgot Password',
				BACK_BUTTON: 'Back',
				PRIVACY: 'Privacy',
				LEGAL: 'Legal',
				CONTACT: 'Contact',
				CONTACT_ADMIN: 'Contact Your Admin'
			},
			LOGIN: {
				TITLE: 'Login Account',
				BUTTON: 'Sign In',
			},
			FORGOT: {
				TITLE: 'Forgotten Password?',
				DESC: 'Enter your email to reset your password',
				SUCCESS: 'Your account has been successfully reset.'
			},
			REGISTER: {
				TITLE: 'Sign Up',
				DESC: 'Enter your details to create your account',
				SUCCESS: 'Your account has been successfuly registered.'
			},
			INPUT: {
				EMAIL: 'Email',
				FULLNAME: 'Fullname',
				PASSWORD: 'Password',
				CONFIRM_PASSWORD: 'Confirm Password',
				USERNAME: 'Username'
			},
			VALIDATION: {
				INVALID: '{{name}} is not valid',
				REQUIRED: '{{name}} is required',
				MIN_LENGTH: '{{name}} minimum length is {{min}}',
				AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
				NOT_FOUND: 'The requested {{name}} is not found',
				INVALID_LOGIN: 'The login detail is incorrect',
				REQUIRED_FIELD: 'Required field',
				MIN_LENGTH_FIELD: 'Minimum field length:',
				MAX_LENGTH_FIELD: 'Maximum field length:',
				INVALID_FIELD: 'Field is not valid',
			}
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Selected records count: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'eCommerce',
			CUSTOMERS: {
				CUSTOMERS: 'Customers',
				CUSTOMERS_LIST: 'Customers list',
				NEW_CUSTOMER: 'New Customer',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Customer Delete',
					DESCRIPTION: 'Are you sure to permanently delete this customer?',
					WAIT_DESCRIPTION: 'Customer is deleting...',
					MESSAGE: 'Customer has been deleted'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Customers Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected customers?',
					WAIT_DESCRIPTION: 'Customers are deleting...',
					MESSAGE: 'Selected customers have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected customers',
					MESSAGE: 'Selected customers status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Customer has been updated',
					ADD_MESSAGE: 'Customer has been created'
				}
			},

			PRODUCTS: {
				PRODUCTS: 'Products',
				PRODUCTS_LIST: 'Products list',
				NEW_PRODUCT: 'New Product',
				EDIT_PRODUCT: 'Edit Product',
				DELETE_PRODUCT_SIMPLE: {
					TITLE: 'Product Delete',
					DESCRIPTION: 'Are you sure to permanently delete this product?',
					WAIT_DESCRIPTION: 'Product is deleting...',
					MESSAGE: 'Product has been deleted'
				},
				DELETE_PRODUCT_MULTY: {
					TITLE: 'Product Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected products?',
					WAIT_DESCRIPTION: 'Products are deleting...',
					MESSAGE: 'Selected products have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected products',
					MESSAGE: 'Selected products status have successfully been updated'
				},
				EDIT: {
					TITLE:'Edit Product',
					UPDATE_MESSAGE: 'Product has been updated',
					ADD_MESSAGE: 'Product has been created',
				}
			},

			CATEGORIES: {
				CATEGORIES: 'Categories',
				CATEGORIES_LIST: 'Categories',
				NEW_CATEGORY: 'New Category',

				DELETE_CATEGORY_SIMPLE: {
					TITLE: 'Category Delete',
					DESCRIPTION: 'Are you sure to permanently delete this category?',
					WAIT_DESCRIPTION: 'Category is deleting...',
					DELETE_SUCCESS: 'Category has been deleted',
					FAILED: 'Deleting Category has been failed !'
				},
				DELETE_CATEGORY_MULTY: {
					TITLE: 'CATEGORIES Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected categories?',
					WAIT_DESCRIPTION: 'Categories are deleting...',
					MESSAGE: 'Selected categories have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected categories',
					MESSAGE: 'Selected categories status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Category has been updated',
					ADD_MESSAGE: 'Category has been created'
				},

				data :{
					integrity :{
						violation: 'Can\'t delete this category try to empty it first !'
					}
				}
			},
			ORDERS: {
				ORODRES: 'Orders',
				ORDERS_LIST: 'Commandes',
				NEW_ORDER: 'New Order',

				DELETE_ORDER_SIMPLE: {
					TITLE: 'Order Delete',
					DESCRIPTION: 'Are you sure to permanently delete this order?',
					WAIT_DESCRIPTION: 'Order is deleting...',
					DELETE_SUCCESS: 'Order has been deleted',
					FAILED: 'Deleting Order has been failed !'
				},
				DELETE_ORDER_MULTY: {
					TITLE: 'Orders Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected orders?',
					WAIT_DESCRIPTION: 'Orders are deleting...',
					MESSAGE: 'Selected orders have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected orders',
					MESSAGE: 'Selected orders status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Order has been updated',
					ADD_MESSAGE: 'Order has been created'
				},

				data :{
					integrity :{
						violation: 'Can\'t delete this order try to empty it first !'
					}
				}
			},

			CONFIGURATIONS: {
					data :{
						integrity:{
							violation: 'Can\'t delete this configuration because it depends on other entities !'
						}
					}
			}
		}
	}
};
